import * as QRCode from 'qrcode';

export async function toQrDataUrl(text: string, size: number = 220): Promise<string> {
  const value = String(text || '').trim();
  if (!value) throw new Error('Missing QR text');
  return QRCode.toDataURL(value, {
    errorCorrectionLevel: 'M',
    margin: 1,
    width: Math.max(120, size | 0),
  });
}

